import { Component} from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, RouterModule } from '@angular/router';
import { FloatingDivComponent } from './floating-div/floating-div.component';
import { MatTabsModule } from '@angular/material/tabs';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {FormsModule} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AboutComponent } from './about/about.component';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import { MobileoptionsComponent } from "./mobileoptions/mobileoptions.component";
import { DeviceDetectorService } from 'ngx-device-detector';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { SpinnerComponent } from "./spinner/spinner.component";




@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [RouterModule, MatTabsModule, DragDropModule, FormsModule, MatIconModule, MatMenuModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule, SpinnerComponent]
})
export class AppComponent {
  isMobile=false;
  loading: boolean=false;
  title = 'Food Catering Website';
  constructor(private router: Router,private deviceService: DeviceDetectorService) {
    
    this.isMobile=this.deviceService.isMobile();
    if(!this.isMobile)
      this.router.navigate(['./home']);
    else
      this.router.navigate(['./mhome']);
  }

  openMenuAboutUs(): void {
    this.router.navigate(['./about']);
  }
  openMenuHome(): void {
    if(!this.isMobile)
      this.router.navigate(['./home']);
    else
      this.router.navigate(['./mhome']);
    
  }
  openMenuReviews(): void {
    this.router.navigate(['./reviews']);
    
  }

  openMenuAdmin():void{
    this.router.navigate(['./admin-page']);
  }

  openMenufindus():void{
    this.router.navigate(['./findus']);
  }

   openMenugallery():void{
    this.router.navigate(['./carousel']);
  }

  

  callus(): void{
    window.location.href = 'tel://' + "8240714593";
  }




  
}